import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, OnDestroy, OnInit, PLATFORM_ID, input } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'clever-recomcount',
    templateUrl: './recomcount.component.html',
    styleUrls: ['./recomcount.component.scss'],
    standalone: false
})
export class RecomcountComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    readonly mode = input<string>(undefined);
    isBrowser: boolean = false;
    currentSelected: number = 0;
    step: number = 10;

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.currentSelected = filter.recommendationcount ? filter.recommendationcount : 0;
            this.cdr.detectChanges();
        });
    }

    selectValue(val) {
        if (this.currentSelected === val) {
            this.currentSelected = 0;
        } else {
            this.currentSelected = val;
        }

        this.hotelService.recommendationcount(this.currentSelected, this.mode() !== 'home');
    }

    valueChange(): void {
        this.hotelService.recommendationcount(this.currentSelected, this.mode() !== 'home');
    }
}
